import { Sun, Cloud, CloudRain, CloudSnow, Wind } from 'lucide-react';

const FORECAST = [
  { day: 'Today', temp: 18, icon: 'sun' },
  { day: 'Fri', temp: 16, icon: 'cloud' },
  { day: 'Sat', temp: 20, icon: 'sun' },
  { day: 'Sun', temp: 14, icon: 'rain' },
  { day: 'Mon', temp: 15, icon: 'cloud' },
  { day: 'Tue', temp: 17, icon: 'sun' },
  { day: 'Wed', temp: 19, icon: 'sun' },
];

const ICONS: Record<string, any> = { sun: Sun, cloud: Cloud, rain: CloudRain, snow: CloudSnow };

export function WeatherWidget() {
  return (
    <div className="mx-4 p-3 rounded-xl bg-gradient-to-r from-[#6C3CE1]/10 to-[#FF6B5A]/10">
      <div className="flex gap-3 overflow-x-auto no-scrollbar">
        {FORECAST.map(f => {
          const Icon = ICONS[f.icon] || Sun;
          return (
            <div key={f.day} className="flex flex-col items-center flex-shrink-0 min-w-[48px]">
              <span className="text-xs text-gray-500">{f.day}</span>
              <Icon size={18} className="my-1 text-[#6C3CE1]" />
              <span className="text-sm font-semibold">{f.temp}°</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
